/** The phone's position for tagging a loom. Indoors GPS can be off by tens of metres; the accuracy is kept. */
export type Fix = { lat: number; lng: number; accuracyMeters: number | null };

export const currentPosition = (): Promise<Fix> =>
  new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("This phone can't share its location here"));
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) => resolve({ lat: p.coords.latitude, lng: p.coords.longitude, accuracyMeters: p.coords.accuracy ?? null }),
      (e) =>
        reject(
          new Error(
            e.code === e.PERMISSION_DENIED
              ? "Location is blocked. Allow it for this site in the phone's settings."
              : "Couldn't get a location. Step near a door or window and try again."
          )
        ),
      { enableHighAccuracy: true, timeout: 20000, maximumAge: 0 }
    );
  });

export const mapLink = (lat: number, lng: number) => `https://www.google.com/maps?q=${lat},${lng}`;
